import { render } from "./TranslationOptions copy.vue?vue&type=template&id=75fc30c0&scoped=true"
import script from "./TranslationOptions copy.vue?vue&type=script&lang=js"
export * from "./TranslationOptions copy.vue?vue&type=script&lang=js"

import "./TranslationOptions copy.vue?vue&type=style&index=0&id=75fc30c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fc30c0"]])

export default __exports__